import React from 'react';
import ReactDOM from 'react-dom';
import intersection from 'lodash/intersection';

import Container from './styled/Container';
import ViewButton from './styled/ViewButton';
import StyledMenu from './styled/StyledMenu';

import Header from './dialogues/Header/Dialogue';
import Blockquote from './dialogues/Blockquote/Dialogue';
import { BulletedList, NumberedList } from './dialogues/List/Dialogue';
import Image from './dialogues/Image/Dialogue';
import Code from './dialogues/Code/Dialogue';

class BlockMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      above: false,
    };

    this.ImageDialogue = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.props;
    const { startBlock } = value;
    const { type } = startBlock;

    // Close up open menu when entering to new line
    if (
      type === 'paragraph' && // New block is paragraph
      this.state.open === true && // Menu will be open
      prevState.open === true // Menu was open
    ) {
      this.setState({open: false}); // eslint-disable-line react/no-did-update-set-state
    }
  }

  hasActiveBlockquote(value) {
    const parent = value.document.getParent(value.blocks.first().key);
    return parent && parent.type === 'blockquote';
  }

  hasActiveBlock() {
    const { value } = this.props;

    if (this.hasActiveBlockquote(value)) return true;

    const blockTypes = value.blocks.map(node => node.type);
    const types = [
      'heading-three',
      'list-item',
      'editable-code',
    ];

    return intersection(blockTypes.toJS(), types).length > 0;
  }

  render() {
    const {
      className,
      innerRef,
      editor,
      onChange,
      imageAPI,
      authorization,
    } = this.props;

    const root = window.document.getElementsByTagName('body')[0] || document.root;

    let activeBlock = this.hasActiveBlock();

    const dialogueProps = {editor, onChange};

    const Menu = (
      <StyledMenu
        className={className}
        above={this.state.above}
        hidden={!this.state.open && !activeBlock}
      >
        <Header {...dialogueProps} />
        <Blockquote {...dialogueProps} />
        <BulletedList {...dialogueProps} />
        <NumberedList {...dialogueProps} />
        <Image {...dialogueProps} {...{imageAPI, authorization}} />
        <Code {...dialogueProps} />
      </StyledMenu>
    );

    return ReactDOM.createPortal(
      <Container className='blockMenu' innerRef={innerRef}>
        <ViewButton
          active={this.state.open || activeBlock}
          above={this.state.above}
          onClick={(e) => {
            const { y } = e.target.getBoundingClientRect();
            const { height } = window.visualViewport;
            this.setState(prevState => ({
              open: !prevState.open,
              above: height < (y + 275),
            }));
            this.props.editor.focus();
          }}
        >
          <i className='fas fa-angle-double-right fa-lg' />
        </ViewButton>
        {Menu}
      </Container>,
      root
    );
  }
}

export default BlockMenu;
